export const PRESET_ORBITS = {
  iss: {
    name: "ISS",
    altitude: 408,
    eccentricity: 0,
    inclination: 51.6,
  },
  leo: {
    name: "LEO (Equatorial)",
    altitude: 400,
    eccentricity: 0,
    inclination: 0,
  },
  gps: {
    name: "GPS",
    altitude: 20200,
    eccentricity: 0,
    inclination: 55,
  },
  geo: {
    name: "GEO",
    altitude: 35786,
    eccentricity: 0,
    inclination: 0,
  },
  molniya: {
    name: "Molniya",
    altitude: 39354,
    eccentricity: 0.74,
    inclination: 63.4,
  },
};

export const ENGINE_TYPES = {
  chemical: {
    name: "Chemical",
    isp: 300,
    description: "Typical chemical propulsion (e.g., hydrazine)",
  },
  ion: {
    name: "Ion",
    isp: 3000,
    description: "Electric propulsion (e.g., Hall thruster)",
  },
  hybrid: {
    name: "Hybrid",
    isp: 450,
    description: "Hybrid rocket motor",
  },
};

export const ORBIT_TYPES = {
  LEO: { min: 160, max: 2000, color: "#10b981" },
  MEO: { min: 2000, max: 35786, color: "#f59e0b" },
  GEO: { altitude: 35786, color: "#ef4444" },
  HEO: { min: 35786, max: 100000, color: "#8b5cf6" },
};